import { connect } from 'react-redux';
import { getFormError, getFormSubmitErrors, hasSubmitSucceeded, isSubmitting } from 'redux-form';

import { FORMS } from 'common/Constants';
import { setPassengerUpdateStatus } from 'common/SearchStore/SearchActions';
import { getB2CUserData } from 'common/SearchStore/SearchSelectors';
import UserInfo from './UserInfo';

const mapStateToProps = (state) => {
  return {
    b2cUserData: getB2CUserData(state),
    submitSucceeded: hasSubmitSucceeded(FORMS.SEARCH_BY_USER)(state),
    submitFailed: getFormError(FORMS.SEARCH_BY_USER)(state),
    submitErrors: getFormSubmitErrors(FORMS.SEARCH_BY_USER)(state),
    isSubmitting: isSubmitting(FORMS.SEARCH_BY_USER)(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleActionClicked: () => {
    dispatch(setPassengerUpdateStatus(null));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);
